import React from "react";
import { getNotificationTypeHeadline } from "../layout/header/notifications/notification-box/notification-helpers";
import { isChatNotification } from "../../notification-constants";
import { ListChatNotification } from "./types/ListChatNotification";
import { ListContentNotification } from "./types/ListContentNotification";

/**
 * ListNotification component - optimized for list display contexts
 * Determines which list-optimized component to render based on notification type
 */
export const ListNotification = ({
  notification,
  setIsNotificationsMenuOpen,
  prevNotification,
  isLast = false,
}) => {
  // Determine which component to render based on notification type
  if (isChatNotification(notification.notificationType)) {
    return (
      <ListChatNotification
        notification={notification}
        setIsNotificationsMenuOpen={setIsNotificationsMenuOpen}
        prevNotification={prevNotification}
        getNotificationTypeHeadline={getNotificationTypeHeadline}
        isLast={isLast}
      />
    );
  }

  // Default to content notification for all other types
  return (
    <ListContentNotification
      notification={notification}
      setIsNotificationsMenuOpen={setIsNotificationsMenuOpen}
      prevNotification={prevNotification}
      getNotificationTypeHeadline={getNotificationTypeHeadline}
      isLast={isLast}
    />
  );
};
